<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />


    <!--    점검대상-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 점검대상-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    기계톱 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "기계톱 작업",
      form: {
        inspectionTitle: "기계톱 작업",
        stdInfo: {},
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label:
            "기계톱 사용 전에 볼트･너트 체결상태, 톱날, 방호장치* 상태, 누유여부 등을 확인한 후 작업을 시작하는가?\n" +
            "* 전방 방호판, 체인 브레이크 조작판, 체인잡이, 진동방지장치 등",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "기계톱 시동 전 주변에 근로자와 연료, 장애물이 없는지 확인하고, 지면에서 기계톱을 작동하는가?",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "킥백(Kick Back)현상*을 방지하기 위해 기계톱 톱날 회전 방향에 맞는 절단 방법을 준수하여 작업하는가?\n" +
            "* 회전하는 톱체인(가이드바) 끝의 상단부분이 어떤 물체에 닿아서 체인톱이 작업자 쪽으로 튀는 현상",
          is_checked: "",
        },
        {
          id: 4,
          label: "연료 용기는 연료누출이 없고, 위험물질 경고표지를 부착하는가?",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "작업자에게 안전모, 보안경, 방진장갑 등 작업에 적절한 보호구를 지급･착용토록 하는가?",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "기계톱 작업 시 섬유조직이 톱날의 회전을 멈추게 할 수 있는 안전바지및 무릎보호대를 착용하는가?",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "다른 지점으로 이동하거나, 톱을 사용하지 않을 때는 체인톱날이 돌지않게 체인 브레이크를 사용하고, 먼 거리 이동 시 엔진을 정지하고 안전덮개를 부착하는가?",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "기계톱의 정비･청소･급유 등을 할 때 반드시 기계톱의 운전을 정지한 후에 작업을 실시하는가?",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "작업 전 작업자 및 신호수가 작업구역, 작업 순서 및 방법, 신호체계 등을 숙지하였는지 확인한 후 작업을 시작하는가?",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "기계톱에 설치된 방호장치를 임의로 해체하거나 기능을 정지하지 않는가?",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
